import {AxiosInstance} from "axios";
import FinanceProduct from "../model/financeProduct/FinanceProduct";
import {CreateUpdateFinanceProductApiDto} from "./model/rest";

export default class FinanceProductApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch finance products
	 * @return {Promise<FinanceProduct[]>} Promise containing fetched categories.
	 */
	fetchFinanceProducts(): Promise<FinanceProduct[]> {
		const url = `/api/web/finance_products`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(FinanceProduct.fromJson));
	}

	/**
	 * Update finance products sort order.
	 * @param {string[]} financeProductIds
	 * @returns {Promise<any>}
	 */
	updateFinanceProductsSortOrder(financeProductIds: string[]) {
		const url = `/api/web/finance_products/order`;
		return this.axiosInstance.put(url, financeProductIds);
	}

	/**
	 * Create finance product.
	 * @param data
	 * @returns {Promise<FinanceProduct>}
	 */
	createFinanceProduct(data: CreateUpdateFinanceProductApiDto): Promise<FinanceProduct> {
		const url = `/api/web/finance_products`;
		return this.axiosInstance.post(url, data).then(resp => FinanceProduct.fromJson(resp.data));
	}

	/**
	 * Update finance product action.
	 */
	updateFinanceProduct(fpId: string, data: FinanceProduct): Promise<FinanceProduct> {
		const url = `/api/web/finance_products/${fpId}`;
		return this.axiosInstance.put(url, data.toJson()).then(resp => FinanceProduct.fromJson(resp.data));
	}
}